<template>
    <v-card width="40vw" height="30vh">
        <v-toolbar color="primary" dark>
            <v-toolbar-title class="dialog-toolbar">
                {{ title }} {{ name }}
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="text-center">
            <v-progress-circular
                color="blue-lighten-3"
                indeterminate
                :size="120"
            >
                <v-img
                    src="images/D3_Connectv2.png"
                    :size="10"
                    class="loading-spinner"
                    :style="{
                        marginLeft: '9px',
                    }"
                    indeterminate
                ></v-img>
            </v-progress-circular>
            <br />
            <div class="mt-7">Processing... This may take a couple seconds</div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "ClockingLoader",
    props: {
        title: String,
        name: String,
    },
};
</script>
<style scoped>
.dialog-toolbar {
    font-size: 2em;
    line-height: 1.2;
}
</style>
